export const ipBackend = "https://serova.id/";
// export const ipBackend = "http://8.215.33.60:8026/";
// export const ipBackend = "http://localhost:3000/";
